import { render, staticRenderFns } from "./FrequentAddressesList.vue?vue&type=template&id=01b46290&scoped=true&"
import script from "./FrequentAddressesList.vue?vue&type=script&lang=js&"
export * from "./FrequentAddressesList.vue?vue&type=script&lang=js&"
import style0 from "./FrequentAddressesList.vue?vue&type=style&index=0&id=01b46290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b46290",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b46290')) {
      api.createRecord('01b46290', component.options)
    } else {
      api.reload('01b46290', component.options)
    }
    module.hot.accept("./FrequentAddressesList.vue?vue&type=template&id=01b46290&scoped=true&", function () {
      api.rerender('01b46290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/FrequentAddresses/components/FrequentAddressesList.vue"
export default component.exports